import * as React from "react"
import { Link } from "gatsby"

const Layout = ({ location, title, numPages, children }) => {
  const rootPath = `${__PATH_PREFIX__}/`
  const isRootPath = location.pathname === rootPath
  const numClass = numPages > 1 ? 'has--cross-page--pagination' : ''
  let heading, nav, navFooter

  nav = (
    <nav className="d-flex flex-wrap justify-content-center justify-content-md-start py-2">
      <div>
        <Link title="Go to home page" to="/">
          Home
        </Link>
        <span aria-hidden="true" className="mx-2">·</span>
      </div>
      <div>
        <Link title="Go to blog index" to="/blog">
          Blog
        </Link>
        <span aria-hidden="true" className="mx-2">·</span>
      </div>
      <div>
        <Link title="Go to code snippet index" to="/code-snippets">
          Code Snippets
        </Link>
        <span aria-hidden="true" className="mx-2">·</span>
      </div>
      <div>
        <Link title="Go to products page" to="/products">
          Products
        </Link>
        <span aria-hidden="true" className="mx-2">·</span>
      </div>
      <div>
        <Link title="Go to works page" to="/works">
          Works
        </Link>
        <span aria-hidden="true" className="mx-2">·</span>
      </div>
      <div>
        <Link title="Go to about page" to="/about">
          About
        </Link>
      </div>
    </nav>
  )

  navFooter = (
    <nav className="d-flex flex-wrap justify-content-center justify-content-md-start text-muted py-2">
      <div>
        <Link className="text-400" title="Go to home page" to="/">
          Home
        </Link>
        <span aria-hidden="true" className="mx-2">·</span>
      </div>
      <div>
        <Link className="text-400" title="Go to blog index" to="/blog">
          Blog
        </Link>
        <span aria-hidden="true" className="mx-2">·</span>
      </div>
      <div>
        <Link className="text-400" title="Go to code snippet index" to="/code-snippets">
          Code Snippets
        </Link>
        <span aria-hidden="true" className="mx-2">·</span>
      </div>
      <div>
        <Link className="text-400" title="Go to about page" to="/about">
          About
        </Link>
        <span aria-hidden="true" className="mx-2">·</span>
      </div>
      <div>
        <Link className="text-400" title="Go to products page" to="/products">
          Products
        </Link>
        <span aria-hidden="true" className="mx-2">·</span>
      </div>
      <div>
        <Link className="text-400" title="Go to works page" to="/works">
          Works
        </Link>
        <span aria-hidden="true" className="mx-2">·</span>
      </div>
      <div>
        <Link className="text-400" title="Go to cookie policy page" to="/cookie-policy">
          Cookie Policy
        </Link>
        <span aria-hidden="true" className="mx-2">·</span>
      </div>
      <div>
        <Link className="text-400" title="Go to MIT license page" to="/mit">
          MIT License
        </Link>
      </div>
    </nav>
  )

  heading = (
    <div className="d-flex align-items-center justify-content-center justify-content-md-between py-2">
      <Link to="/" title="Onur Boz Home Page" className="link-400">
        <svg aria-hidden="true" fill="currentColor" width="104" height="42" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 925.6 535.3"><path d="M539.6 267.6L462.5 134l.1-.2H309.2l-.1-.1L386.3 0H231.8l.1.2-77.1 133.6h-.7l.1.2-77.1 133.6H77h.1l.1.1L.1 401.4H0h.1L77.2 535l-.1.2H539.8l-77.2-133.7.1-.1h.1-.1l-.1-.1 77-133.7zM308.2 401.4H154.4l-.1-.1 77.1-133.6H385.3l.1.1-77.2 133.6zM925.6 401.4H771.4v-.1l77.1-133.6v-.1L771.4 134l.1-.2H617l.1.2-77.2 133.7h154.2l.1.1L617 401.4v.1l.1.1-77.2 133.7h308.6l-.1-.2z" /></svg>
        <div className="text-center text-400 mb-0 =xs">
          {title}
        </div>
      </Link>
    </div>
  )

  return (
    <div className="global-wrapper" data-is-root-path={isRootPath}>
      <header className="global-header py-4 mb-4">
        <div className="container container-max-md">
          <div className="row align-items-center">
            <div className="col-md-auto">
              {heading}
            </div>
            <div className="col-md">
              {nav}
            </div>
          </div>
        </div>
      </header>
      <main>{children}</main>
      <footer className={numClass}>
        <div className="container container-max-md mt-5 text-400">
          <div className="small border-top border-secondary py-2 my-3">
            {navFooter}
          </div>
          <p className="small">
            © {new Date().getFullYear()} onurboz.com, Onur Boz, Boz All rights reserved.
          </p>
          <p className="text-muted =xs">
            ❤️ Made with the power of node.js, react.js, gatsby.js and firebase. Unless stated otherwise, all published code is free under the <Link title="Go to MIT license page" to="/mit">MIT License</Link>.
          </p>
        </div>
      </footer>
    </div>
  )
}

export default Layout
